import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Button } from "@/components/Buttons";
import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { ButtonLink } from "@/components/Buttons/index";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import { useModal, useNotification, usePaymentInstrumentsDeactivateMutation, usePaymentInstrumentsQuery } from "@/hooks";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import routes from "@/lib/routes";
import accountStyles from "@/styles/Account.module.scss";
import styles from "@/styles/AccountPayment.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import isEmpty from "lodash/isEmpty";
import { useCallback, useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};
IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
function ModalContent(_ref) {
  let {
    paymentInstrumentId,
    paymentMethodId,
    cardType,
    paymentMethod,
    cardNumber,
    expireFormatted,
    onDark,
    paymentInstrumentsDeactivate
  } = _ref;
  const {
    hideModal
  } = useModal();
  const handleOnClick = useCallback(() => {
    paymentInstrumentsDeactivate({
      variables: {
        payment_instrument_id: paymentInstrumentId
      }
    });
    hideModal();
  }, [paymentInstrumentId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h4", {
      children: "\u672C\u5F53\u306B\u3053\u306E\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
    }), /*#__PURE__*/_jsx("div", {
      className: modalStyles.confirmPaymentMethod,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${accountStyles.itemTerm} ${styles.paymentMethodIcon}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: paymentMethodId,
            cardType: cardType,
            onDark: onDark
          })
        }), (paymentMethodId == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS || paymentMethodId == PAYMENT_METHOD_ID.CREDIT_CARD_3DS) && paymentMethod && /*#__PURE__*/_jsxs("div", {
          className: styles.cardInfo,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.cardNumber,
            children: cardNumber
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.expireDate,
            children: ["\u6709\u52B9\u671F\u9650\uFF1A", expireFormatted]
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: `${modalStyles.btnArea} ${modalStyles.multiple}`,
      children: [/*#__PURE__*/_jsx(Button, {
        borderGray: true,
        fontFixed: true,
        large: true,
        onClick: () => hideModal(),
        children: "\u30AD\u30E3\u30F3\u30BB\u30EB"
      }), /*#__PURE__*/_jsx(Button, {
        fillCautionColor: true,
        fontFixed: true,
        large: true,
        onClick: handleOnClick,
        children: "\u524A\u9664\u3059\u308B"
      })]
    })]
  });
}
function ErrorModalContent(_ref2) {
  let {
    paymentMethodId,
    cardType,
    paymentMethod,
    cardNumber,
    expireFormatted,
    onDark
  } = _ref2;
  const {
    hideModal
  } = useModal();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("h4", {
      className: modalStyles.caution,
      children: [/*#__PURE__*/_jsx(IconCaution, {}), "\u3053\u306E\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306F\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002"]
    }), /*#__PURE__*/_jsx("div", {
      className: modalStyles.confirmPaymentMethod,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${accountStyles.itemTerm} ${styles.paymentMethodIcon}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: paymentMethodId,
            cardType: cardType,
            onDark: onDark
          })
        }), (paymentMethodId == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS || paymentMethodId == PAYMENT_METHOD_ID.CREDIT_CARD_3DS) && paymentMethod && /*#__PURE__*/_jsxs("div", {
          className: styles.cardInfo,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.cardNumber,
            children: cardNumber
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.expireDate,
            children: ["\u6709\u52B9\u671F\u9650\uFF1A", expireFormatted]
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("p", {
      children: ["\u3053\u306E\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306F\u73FE\u5728\u8CFC\u5165\u4E2D\u306E\u6708\u984D\u5546\u54C1\u304C\u3042\u308B\u305F\u3081\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002", /*#__PURE__*/_jsx("br", {}), "\u524A\u9664\u3057\u305F\u3044\u5834\u5408\u306F\u8A72\u5F53\u5546\u54C1\u306E\u652F\u6255\u3044\u65B9\u6CD5\u3092\u5909\u66F4\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"]
    }), /*#__PURE__*/_jsx("div", {
      className: `${modalStyles.btnArea} ${modalStyles.multiple}`,
      children: /*#__PURE__*/_jsx(ButtonMultiClick, {
        borderGray: true,
        fontFixed: true,
        large: true,
        onClick: () => hideModal(),
        children: "\u9589\u3058\u308B"
      })
    })]
  });
}
export default function PaymentMethod() {
  const {
    showNotification
  } = useNotification();
  const {
    showModal
  } = useModal();
  const {
    data,
    loading,
    refetch
  } = usePaymentInstrumentsQuery({
    variables: {},
    fetchPolicy: "cache-first"
  });
  useEffect(() => {
    refetch();
  }, []);
  const [paymentInstrumentsDeactivate] = usePaymentInstrumentsDeactivateMutation({
    onCompleted: _ref3 => {
      var _paymentInstrumentsDe;
      let {
        paymentInstrumentsDeactivate
      } = _ref3;
      console.log("paymentInstrumentsDeactivate", paymentInstrumentsDeactivate);
      if (paymentInstrumentsDeactivate !== null && paymentInstrumentsDeactivate !== void 0 && (_paymentInstrumentsDe = paymentInstrumentsDeactivate.error) !== null && _paymentInstrumentsDe !== void 0 && _paymentInstrumentsDe.message) {
        showModal( /*#__PURE__*/_jsx(ErrorModalContent, {
          paymentMethodId: paymentInfo.paymentMethodId,
          cardType: paymentInfo.cardType,
          paymentMethod: paymentInfo.paymentMethod,
          cardNumber: paymentInfo.cardNumber,
          expireFormatted: paymentInfo.expireFormatted,
          onDark: paymentInfo.onDark
        }), {
          closeButton: false,
          outerAreaClose: false,
          style: "dialogue"
        });
      } else if (paymentInstrumentsDeactivate !== null && paymentInstrumentsDeactivate !== void 0 && paymentInstrumentsDeactivate.payment_instrument_id) {
        showNotification("お支払い方法を削除しました", {
          time: 2000
        });
        console.log("refetch");
        refetch();
      }
    }
  });
  const {
    0: paymentInfo,
    1: setPaymentInfo
  } = useState({});
  const handleClick = useCallback((paymentInstrumentId, paymentMethodId, cardType, paymentMethod, cardNumber, expireFormatted, onDark) => {
    setPaymentInfo({
      paymentMethodId,
      cardType,
      paymentMethod,
      cardNumber,
      expireFormatted,
      onDark
    });
    showModal( /*#__PURE__*/_jsx(ModalContent, {
      paymentInstrumentId: paymentInstrumentId,
      paymentMethodId: paymentMethodId,
      cardType: cardType,
      paymentMethod: paymentMethod,
      cardNumber: cardNumber,
      expireFormatted: expireFormatted,
      onDark: onDark,
      paymentInstrumentsDeactivate: paymentInstrumentsDeactivate
    }), {
      closeButton: false,
      outerAreaClose: false,
      style: "dialogue"
    });
  }, [setPaymentInfo]);
  const paymentInstrumentData = data === null || data === void 0 ? void 0 : data.paymentInstruments;
  const paymentInstrumentsList = paymentInstrumentData && paymentInstrumentData.map(d => {
    const cardNumber = " ****-****-****-" + d.values.card_number;
    const expireDate = d.values.expiry_date;
    let expireFormatted;
    if (expireDate) {
      const expireList = expireDate.split("/");
      let [month, year] = expireList;
      year = "20" + year;
      expireFormatted = year + "/" + month;
    }
    const id = d.payment_instrument_id;
    const onDark = true;
    return /*#__PURE__*/_jsxs("div", {
      className: accountStyles.contentItem,
      children: [/*#__PURE__*/_jsxs("div", {
        className: `${accountStyles.itemTerm} ${styles.paymentMethodIcon}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: d.payment_method_id,
            cardType: d.values.card_type,
            onDark: onDark
          })
        }), (d.payment_method_id == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS || d.payment_method_id == PAYMENT_METHOD_ID.CREDIT_CARD_3DS) && d.payment_method && /*#__PURE__*/_jsxs("div", {
          className: styles.cardInfo,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.cardNumber,
            children: cardNumber
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.expireDate,
            children: ["\u6709\u52B9\u671F\u9650\uFF1A", expireFormatted]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: `${accountStyles.itemValue}`,
        children: /*#__PURE__*/_jsx("div", {
          className: `${accountStyles.itemLink} ${styles.deleteLink}`,
          children: /*#__PURE__*/_jsx("a", {
            onClick: () => handleClick(id, d.payment_method_id, d.values.card_type, d.payment_method, cardNumber, expireFormatted, onDark),
            children: "\u524A\u9664\u3059\u308B"
          })
        })
      })]
    }, d.payment_method.name + d.payment_instrument_id);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: accountStyles.paymentMethod,
      children: /*#__PURE__*/_jsx("div", {
        className: accountStyles.contentsInner,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${accountStyles.contentBox} ${styles.paymentMethod}`,
          children: [/*#__PURE__*/_jsxs("div", {
            className: accountStyles.contentHeader,
            children: [/*#__PURE__*/_jsx("h3", {
              className: accountStyles.contentTitle,
              children: "SPOOX ID\u306B\u3054\u767B\u9332\u6E08\u307F\u306E\u304A\u652F\u6255\u65B9\u6CD5"
            }), /*#__PURE__*/_jsx("div", {
              className: accountStyles.contentHeaderLink,
              children: /*#__PURE__*/_jsx(ButtonLink, {
                type: "button",
                fillLightGray: true,
                borderGray: true,
                small: true,
                fontFixed: true,
                href: routes.accountAddPayment,
                children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u8FFD\u52A0"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: accountStyles.contentBody,
            children: paymentInstrumentsList
          }), isEmpty(paymentInstrumentsList) && !loading && /*#__PURE__*/_jsx("div", {
            className: accountStyles.noContent,
            children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093"
          }), /*#__PURE__*/_jsx("div", {
            className: accountStyles.caption,
            children: "\u65B0\u898F\u3067\u306E\u5546\u54C1\u8CFC\u5165\u6642\u306E\u3010\u30AD\u30E3\u30EA\u30A2\u6C7A\u6E08\u3011\u306E\u5BFE\u5FDC\u3092\u7D42\u4E86\u3044\u305F\u3057\u307E\u3057\u305F\u306E\u3067\u3001\u304A\u652F\u6255\u65B9\u6CD5\u3068\u3057\u3066\u8FFD\u52A0\u306F\u3067\u304D\u307E\u305B\u3093"
          })]
        })
      })
    })
  });
}